module.exports = __webpack_public_path__ + "static/media/KMH_5041.26e9bc59.jpg";